function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M37.8,13.1,34.5,9.8,23.8,20.6,34.5,31.4l3.3-3.1-7.3-7.4Z",
  fill: "#59b4d9"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.2,22.2l7.3,7.3-7.3,7.4,3.3,3.3L26.2,29.4,15.5,18.6Z",
  fill: "#59b4d9"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M25,0a25,25,0,0,0,0,50A25.27,25.27,0,0,0,50,25,25.073,25.073,0,0,0,25,0Zm0,3.3A21.7,21.7,0,1,1,3.3,25,21.68,21.68,0,0,1,25,3.3Z",
  fill: "#046eab"
});

var SvgConnections = function SvgConnections(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgConnections, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/connections.8380ed95.svg";
export { ForwardRef as ReactComponent };